export default __webpack_public_path__ + "static/media/feature-3.ac2da0a0.jpg";